import { Page } from "@shapeable/kelp-forest-alliance-types";

export type Guidebook = Page & {
};

const isPageType = (entity: Page, type: string) => {
  return entity.type?.slug === type || entity.types?.[0]?.slug === type;
};

export const isGuidebookPage = (entity: Page): entity is Guidebook => isPageType(entity, 'guidebook');